import { useAuthStore } from "@/store/auth";

export default [
  {
    path: "/app/audit",
    component: () => import("@/modules/settings/views"),
    meta: { requiresAuth: true, title: "Educasis - Logs alterações" },
    beforeEnter: () => [1, 2].includes(Number(useAuthStore().user?.id)) || { name: "app.forbidden" },
    children: [
      {
        path: "",
        name: "auditing.database",
        component: () => import("../views/List.vue"),
      },
    ],
  },
];
